import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./utils/createPromotionCode";
import { App as CapacitorApp } from '@capacitor/app';
import { ErrorBoundary } from "@/components/dev/ErrorBoundary";

// Runtime header height measurement
function applyHeaderOffset() {
  const header =
    document.querySelector<HTMLElement>('header') ||
    document.getElementById('site-header');
  const h = header ? header.getBoundingClientRect().height : 64; // fallback
  const safeTop = Number(getComputedStyle(document.documentElement)
    .getPropertyValue('--safe-top')
    .replace('px','')) || 0;
  // add a small gap so items never peek under the header
  const gap = 12;
  document.documentElement.style.setProperty('--header-h', `${Math.round(h + safeTop + gap)}px`);
}

// run once and on resize
window.addEventListener('DOMContentLoaded', applyHeaderOffset);
window.addEventListener('resize', () => {
  // debounce a bit
  clearTimeout((window as any).__hdr_to);
  (window as any).__hdr_to = setTimeout(applyHeaderOffset, 100);
});

// Runtime error banner for unhandled errors
function showBanner(msg: string) {
  const el = document.createElement("div");
  el.style.cssText = "position:fixed;left:0;right:0;top:0;background:#ffe8e8;color:#900;padding:8px 12px;font:14px/1.4 sans-serif;z-index:2147483647;border-bottom:1px solid #f99";
  el.textContent = msg;
  document.body.appendChild(el);
}
window.addEventListener("error", e => showBanner(`JS error: ${e.message}`));
window.addEventListener("unhandledrejection", e => showBanner(`Promise rejection: ${String((e as any).reason)}`));

// Handle hardware back button for mobile devices
CapacitorApp.addListener('backButton', ({ canGoBack }) => {
  if (canGoBack) {
    window.history.back();
  } else {
    CapacitorApp.exitApp();
  }
});


createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
